import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { Empty } from "antd";
import PlaceOfWorshipModal from "../../../../components/modelpopup/Profile/PlaceOfWorshipModal";

export const PlaceOfWorship = ({details}) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        // Place of worship is an array, get the first item
        const placeData = details?.place_of_worship?.[0] || details?.placeOfWorship;
        setData(placeData);
    }, [details]);

    const refreshData = newData => {
        setData(newData);
    }

    return (
        <div className="card profile-box flex-fill">
            <div className="card-body">
                <h3 className="card-title">Place of Worship
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#place_of_worship_modal"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                </h3>
                {data ? (
                    <ul className="personal-info">
                        <li>
                            <div className="title">Religion</div>
                            <div className="text">{data?.religion || details?.religion || 'N/A'}</div>
                        </li>
                        <li>
                            <div className="title">Name</div>
                            <div className="text">{data?.place_name || 'N/A'}</div>
                        </li>
                        <li>
                            <div className="title">Address</div>
                            <div className="text">{data?.address || 'N/A'}</div>
                        </li>
                        <li>
                            <div className="title">Name of Pastor/Imam</div>
                            <div className="text">{data?.pastor_priest_name || 'N/A'}</div>
                        </li>
                        <li>
                            <div className="title">Phone No.</div>
                            <div className="text">{data?.contact_phone || 'N/A'}</div>
                        </li>
                    </ul>
                ) : (
                    <div className="text-center">
                        <Empty />
                        <button
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#place_of_worship_modal"
                        >
                            <i className="la la-plus mr-1" />Add
                        </button>
                    </div>
                )}
            </div>
            <PlaceOfWorshipModal data={details} refresh={refreshData} />
        </div>
    )
}
